"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "spinete": {
    "ab066009": [{
      "hkey": "f9ae1089",
      "slug": "gennaretto-san-giovanni",
      "name": "Gennaretto-San Giovanni",
      "primary": true,
      "skipSearch": false
    }],
    "gennaretto": [{
      "hkey": "f9ae1089",
      "slug": "gennaretto-san-giovanni",
      "name": "Gennaretto-San Giovanni",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "spinete"
    }],
    "586bd28b": [{
      "hkey": "f9ae1089",
      "slug": "gennaretto-san-giovanni",
      "name": "Gennaretto-San Giovanni",
      "primary": true,
      "skipSearch": false
    }],
    "san-giovanni": [{
      "hkey": "f9ae1089",
      "slug": "gennaretto-san-giovanni",
      "name": "Gennaretto-San Giovanni",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "spinete"
    }]
  }
};
exports["default"] = _default;